/* eslint-disable no-shadow */
import { GAME_ID, REDUX_ACTIONS, ONBOARDING_STAGES } from 'a/cutItOut/data/constants';
import CurriculumManager from 'a/cutItOut/content/CurriculumManager';
import { shuffleArray } from '../../../../lib/utilityFunctions';

export const initialState = {
  onboardingWord: null,
  activePillLabel: null,
  targetWord: {},
  pulsingPill: {
    label: null,
    duration: 0,
    interval: 0,
    isPulsing: false,
  },
  submittedWordLabels: [],
  interactionLocked: false,
  wordsSequence: [],
  placeholderIsHighlighted: false,
  stage: ONBOARDING_STAGES.INSTRUCTION,
};

const onboardingReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ONBOARDING: {
      const targetWord = CurriculumManager.getOnboardingTargetWord(action.payload.levelId, action.payload.language);

      const distractors = CurriculumManager.getOnboardingDistractors(action.payload.levelId, action.payload.language);
      return {
        ...initialState,
        onboardingWord: CurriculumManager.getOnboardingWord(action.payload.levelId, action.payload.language),
        targetWord,
        wordsSequence: shuffleArray([targetWord, ...distractors]),
      };
    }
    case REDUX_ACTIONS.SET_PLACEHOLDER_HIGHLIGHTED:
      return { ...state, placeholderIsHighlighted: action.payload.placeholderIsHighlighted };
    case REDUX_ACTIONS.SET_PULSING_PILL:
      return {
        ...state,
        pulsingPill: {
          label: action.payload.label,
          duration: action.payload.duration,
          interval: action.payload.interval,
          isPulsing: true,
        },
      };
    case REDUX_ACTIONS.SIMPLIFY_ONBOARDING_QUESTION:
      return {
        ...state,
        submittedWordLabels: [...state.submittedWordLabels, action.payload.incorrectPictureLabel],
      };
    case REDUX_ACTIONS.SET_PULSE_FINISHED:
      return {
        ...state,
        pulsingPill: initialState.pulsingPill,
      };
    case REDUX_ACTIONS.SET_HIGHLIGHTED_PILL_LABEL:
      return {
        ...state,
        highlightedPillLabel: action.payload.highlightedPillLabel,
      };
    case REDUX_ACTIONS.SET_ACTIVE_PILL_LABEL:
      return {
        ...state,
        activePillLabel: action.payload.activePillLabel,
      };
    case REDUX_ACTIONS.SET_ONBOARDING_STAGE: {
      return {
        ...state,
        stage: action.payload.stage,
      };
    }
    case REDUX_ACTIONS.SET_ONBOARDING_INTERACTION_LOCKED:
      return {
        ...state,
        interactionLocked: action.payload.interactionLocked,
      };
    default:
      return state;
  }
};

export default onboardingReducer;
